module.exports = __webpack_public_path__ + "img/bindCard.e8d1e1e1.png";